import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {YearMonth} from '../components/ui/datepicker/datepicker-yearmonth.component';
import {claimValue, positiveDecimalToTheHundredthsWithIntegerOrZero, positiveIntegerOrZero} from '../util/patterns/patterns';

export function isNumeric(): ValidatorFn {
  return Validators.pattern(positiveDecimalToTheHundredthsWithIntegerOrZero)
}

export class NotEmptyStringValidator {
  static validate(control: AbstractControl) : ValidationErrors | null {
    if(!!control.value && !(control.value as string).trim()) {
      return {cannotBeEmptyString: true}
    }
    return null;
  }
}

export function isInteger(): ValidatorFn {
  return Validators.pattern(positiveIntegerOrZero)
}

export function isCorrectClaimValue(): ValidatorFn {
  return Validators.pattern(claimValue)
}

export function min(minimal: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const retVal = { min: control.value };
    if (minimal === undefined) return retVal
    const value = Number(control.value)
    if (isNaN(value)) return retVal
    return value < minimal ? retVal : null
  }
}

export function max(maximal: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const retVal = { max: control.value };
    if (maximal === undefined) return retVal
    const value = Number(control.value)
    if (isNaN(value)) return retVal
    return value > maximal ? retVal : null
  }
}

export function isDateFilled(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null) return {yearMonth: true}
    const yearMonth = control.value as YearMonth
    return yearMonth.year === 'NaN' || yearMonth.month === 'NaN' ? {yearMonth: true} : null;
  }
}
